module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl20 pr20"
  }, [_c('div', {
    staticClass: "add_search mt20 clearfix"
  }, [_c('el-button', {
    staticClass: "r ml10 mr20",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.keySearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-input', {
    staticClass: "w325 r",
    attrs: {
      "placeholder": "输入品牌名称关键字，搜索大V店是否已有该品牌"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keySearch($event)
      }
    },
    model: {
      value: (_vm.brand_key),
      callback: function($$v) {
        _vm.brand_key = $$v
      },
      expression: "brand_key"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "add_name mt20"
  }, [_c('div', {
    staticClass: "c_name"
  }, [_c('span', {
    staticClass: "main_word mr4"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌中文名称：")]), _vm._v(" "), (!_vm.alSelect) ? _c('span', {
    staticClass: "main_word f12"
  }, [_vm._v("根据您选择搜索到的大V店已有品牌，系统自动填充中文名称")]) : _c('span', {
    staticClass: "ml8"
  }, [_vm._v(_vm._s(_vm.brandName))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name mt20"
  }, [_c('span', {
    staticClass: "main_word mr4"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌英文名称：")]), _vm._v(" "), (!_vm.alSelect) ? _c('span', {
    staticClass: "main_word f12"
  }, [_vm._v("根据您选择搜索到的大V店已有品牌，系统自动填充英文名称")]) : _c('span', {
    staticClass: "ml8"
  }, [_vm._v(_vm._s(_vm.brandEnname))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "brandInfo",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.brandInfo,
      "label-width": "194px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品牌合作类型："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star123 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "dib vtb ml_10",
    model: {
      value: (_vm.brandType),
      callback: function($$v) {
        _vm.brandType = $$v
      },
      expression: "brandType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.initBook,
      "label": "1"
    }
  }, [_vm._v("图书类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": _vm.initNotBook,
      "label": "2"
    }
  }, [_vm._v("非图书类")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌合作品类："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star123 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "ml_10 vtb",
    attrs: {
      "placeholder": "请选择一级类目"
    },
    on: {
      "change": _vm.getTowList
    },
    model: {
      value: (_vm.cata.first),
      callback: function($$v) {
        _vm.$set(_vm.cata, "first", $$v)
      },
      expression: "cata.first"
    }
  }, _vm._l((_vm.oneList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "vtb",
    attrs: {
      "placeholder": "请选择二级类目"
    },
    on: {
      "change": _vm.getThreeList
    },
    model: {
      value: (_vm.cata.second),
      callback: function($$v) {
        _vm.$set(_vm.cata, "second", $$v)
      },
      expression: "cata.second"
    }
  }, _vm._l((_vm.twoList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "vtb",
    attrs: {
      "placeholder": "请选择三级类目"
    },
    on: {
      "change": _vm.selectInfo
    },
    model: {
      value: (_vm.cata.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.cata, "categoryId", $$v)
      },
      expression: "cata.categoryId"
    }
  }, _vm._l((_vm.threeList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticClass: "vtb",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("添加合作类目")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto",
      "margin-bottom": "22px"
    },
    attrs: {
      "data": _vm.brandInfo.categories,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "主营品类",
      "width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.category.grandName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.parentName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.childrenName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否提供发票",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          attrs: {
            "disabled": _vm.provideInvoice != null
          },
          on: {
            "change": function($event) {
              _vm.selProvideInvoice(scope.row, scope.store)
            }
          },
          model: {
            value: (scope.row.provideInvoice),
            callback: function($$v) {
              _vm.$set(scope.row, "provideInvoice", $$v)
            },
            expression: "scope.row.provideInvoice"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_c('span', {
          staticClass: "f14 f666"
        }, [_vm._v("否")])]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_c('span', {
          staticClass: "f14 f666"
        }, [_vm._v("是")])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发票类型",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "placeholder": "请选择发票类型"
          },
          on: {
            "change": function($event) {
              _vm.selInvoiceType(scope.row)
            }
          },
          model: {
            value: (scope.row.invoiceType),
            callback: function($$v) {
              _vm.$set(scope.row, "invoiceType", $$v)
            },
            expression: "scope.row.invoiceType"
          }
        }, [(_vm.registeredCountry == 1) ? _c('el-option', {
          attrs: {
            "label": "增值税普通发票",
            "value": 1
          }
        }) : _vm._e(), _vm._v(" "), (_vm.registeredCountry == 1 && _vm.taxpayerType == 1) ? _c('el-option', {
          attrs: {
            "label": "增值税专用发票",
            "value": 2
          }
        }) : _vm._e(), _vm._v(" "), (_vm.registeredCountry == 1 && _vm.taxpayerType == 2) ? _c('el-option', {
          attrs: {
            "label": "增值税专用发票（需去税务局代开）",
            "value": 2
          }
        }) : _vm._e(), _vm._v(" "), (_vm.registeredCountry != 1) ? _c('el-option', {
          attrs: {
            "label": "形式发票",
            "value": 3
          }
        }) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "税率",
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return scope.row.ratesStr != null && scope.row.ratesStr != undefined ? [(_vm.taxpayerType == 1 && scope.row.invoiceType == 1) ? _c('el-radio-group', {
          model: {
            value: (scope.row.ratesStr),
            callback: function($$v) {
              _vm.$set(scope.row, "ratesStr", $$v)
            },
            expression: "scope.row.ratesStr"
          }
        }, [_c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "0"
          }
        }, [_vm._v("0%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "6"
          }
        }, [_vm._v("6%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "9"
          }
        }, [_vm._v("9%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "10"
          }
        }, [_vm._v("10%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "13"
          }
        }, [_vm._v("13%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "16"
          }
        }, [_vm._v("16%")])], 1) : _vm._e(), _vm._v(" "), (_vm.taxpayerType == 1 && scope.row.invoiceType == 2) ? _c('el-radio-group', {
          model: {
            value: (scope.row.ratesStr),
            callback: function($$v) {
              _vm.$set(scope.row, "ratesStr", $$v)
            },
            expression: "scope.row.ratesStr"
          }
        }, [_c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "6"
          }
        }, [_vm._v("6%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "9"
          }
        }, [_vm._v("9%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "10"
          }
        }, [_vm._v("10%")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "13"
          }
        }, [_vm._v("13%")]), _vm._v(" "), _c('el-radio', {
          staticStyle: {
            "margin-left": "0px"
          },
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "16"
          }
        }, [_vm._v("16%")])], 1) : _vm._e(), _vm._v(" "), (_vm.taxpayerType == 2) ? _c('el-radio-group', {
          model: {
            value: (scope.row.ratesStr),
            callback: function($$v) {
              _vm.$set(scope.row, "ratesStr", $$v)
            },
            expression: "scope.row.ratesStr"
          }
        }, [_c('el-radio', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "0"
          }
        }, [_vm._v("0%")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "disabled": scope.row.provideInvoice == 0,
            "label": "3"
          }
        }, [_vm._v("3%")])], 1) : _vm._e()] : undefined
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "label": "品类经营特许资质电子版",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-upload', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.franchiseQualification),
            expression: "scope.row.franchiseQualification"
          }],
          staticClass: "hide_up",
          staticStyle: {
            "max-height": "149px",
            "overflow": "hidden"
          },
          attrs: {
            "action": "/suppliers/uploadImageData?biz=0",
            "name": "pic",
            "data": {
              data: scope.$index
            },
            "list-type": "picture-card",
            "file-list": scope.row.franchiseQualificationFile,
            "on-preview": _vm.handlePictureCardPreview,
            "on-remove": _vm.handleRemove,
            "on-success": _vm.handleUpload,
            "before-upload": _vm.beforeUpload
          }
        }, [_c('i', {
          staticClass: "el-icon-plus"
        })]), _vm._v(" "), (!scope.row.franchiseQualification == 1) ? _c('span', [_vm._v("不需要")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "76",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteDomain(scope.$index, _vm.brandInfo.categories)
            }
          }
        }, [_vm._v("删除\n                            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isBook),
      expression: "!isBook"
    }],
    attrs: {
      "label": "商品是否进口："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star123"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "f666 f12 ml_10",
    on: {
      "change": _vm.goodsTypeChange
    },
    model: {
      value: (_vm.brandInfo.goodsType),
      callback: function($$v) {
        _vm.$set(_vm.brandInfo, "goodsType", $$v)
      },
      expression: "brandInfo.goodsType"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": _vm.registeredCountry != 1,
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("非进口")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("进口")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isBook),
      expression: "!isBook"
    }],
    attrs: {
      "label": "品牌经营方式："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star123 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "ml_10 vtb",
    attrs: {
      "placeholder": "请选择品牌经营方式"
    },
    model: {
      value: (_vm.brandInfo.businessType),
      callback: function($$v) {
        _vm.$set(_vm.brandInfo, "businessType", $$v)
      },
      expression: "brandInfo.businessType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "自有品牌"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "代理商"
    }
  }), _vm._v(" "), _c('el-option', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.registeredCountry == 1 && _vm.brandInfo.goodsType == 2) || (_vm.registeredCountry != 1)),
      expression: "(registeredCountry == 1 && brandInfo.goodsType == 2) || (registeredCountry != 1)"
    }],
    attrs: {
      "value": 3,
      "label": "其他"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.isBook && ((_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 1) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry != 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)))) ? _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "商标注册证电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star148"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.brandInfo.trademarkRegistrationCertificateFiles,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemoveTrademark,
      "on-success": _vm.handleSuccess1,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBook && ((_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 1) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry != 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)))) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "上传完整授权链证书电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star204"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.brandInfo.authCertificateFiles,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemoveAuthCert,
      "on-success": _vm.handleSuccess2,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBook && ((_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 3)) ||
    (_vm.registeredCountry != 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 3)))) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "订货单电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star123"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.brandInfo.purchaseOrderFiles,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemovePurchaseOrder,
      "on-success": _vm.handleSuccess3,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBook && ((_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 3)) ||
    (_vm.registeredCountry != 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry != 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 3)))) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "报关单扫描件："
    }
  }, [(!((_vm.registeredCountry != 1 && _vm.brandInfo.businessType == 3) || (_vm.registeredCountry == 1 && _vm.brandInfo.goodsType == 2 && _vm.brandInfo.businessType == 3))) ? _c('span', {
    staticClass: "main_word rule_star123"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("同一批次商品的报关单和出入境检验检疫的证件，复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.brandInfo.customsDeclarationFormFiles,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemoveCustomsForm,
      "on-success": _vm.handleSuccess4,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBook && ((_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 3)) ||
    (_vm.registeredCountry != 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)) ||
    (_vm.registeredCountry != 1 && (_vm.brandInfo.goodsType == 2) && (_vm.brandInfo.businessType == 3)))) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "入境货物检验检疫证明："
    }
  }, [(!((_vm.registeredCountry != 1 && _vm.brandInfo.businessType == 3) || (_vm.registeredCountry == 1 && _vm.brandInfo.goodsType == 2 && _vm.brandInfo.businessType == 3))) ? _c('span', {
    staticClass: "main_word rule_star176"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("同一批次商品的报关单和出入境检验检疫的证件，复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.brandInfo.inspectionQuarantineFiles,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemoveInspectionQuarantine,
      "on-success": _vm.handleSuccess6,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBook && (_vm.registeredCountry == 1 && ((_vm.brandInfo.goodsType == 1) && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)))) ? _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "质检单电子版："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star123"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.brandInfo.qualityInspectionFiles,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemoveQualityInspection,
      "on-success": _vm.handleSuccess5,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isBook && (_vm.registeredCountry == 1 && (_vm.brandInfo.goodsType == 1 && (_vm.brandInfo.businessType == 1 || _vm.brandInfo.businessType == 2)))) ? _c('el-form-item', {
    attrs: {
      "label": "质检日期："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star92 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "ml_10 vtb",
    attrs: {
      "type": "date",
      "placeholder": "请选择质检日期"
    },
    on: {
      "change": _vm.getseconds
    },
    model: {
      value: (_vm.dateTime),
      callback: function($$v) {
        _vm.dateTime = $$v
      },
      expression: "dateTime"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mb20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.search_result,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.search_result = $event
      }
    }
  }, [_c('div', {
    staticClass: "wp100 tc"
  }, [_vm._v("搜索结果如下，若没有您要的品牌，请【添加新品牌】")]), _vm._v(" "), _c('div', {
    staticClass: "mt20 result_radio"
  }, [_c('el-radio-group', {
    staticClass: "radio_group",
    on: {
      "change": _vm.change_select
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, _vm._l((_vm.list), function(val) {
    return _c('el-radio', {
      key: val.brandId,
      staticClass: "list_radio",
      attrs: {
        "label": val.brandId
      }
    }, [_vm._v(_vm._s(val.brandName))])
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.search_result = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.noSelect,
      "type": "primary"
    },
    on: {
      "click": _vm.sure_select
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "visible": _vm.noDialog,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.noDialog = $event
      }
    }
  }, [_c('span', [_vm._v("没有搜索到相关品牌，请[添加新品牌]")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.noDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6286b10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/add_categary_agree/old_brand.vue
// module id = 579
// module chunks = 0